var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-container d-flex flex-column"},[_c('span',{staticClass:"d-block text-4 font-weight-300"},[_vm._v(_vm._s(_vm.formattedDate.day))]),_vm._v(" "),_c('span',{staticClass:"d-block text-1 font-weight-300 text-uppercase"},[_vm._v(" "+_vm._s(_vm.formattedDate.month))])])
}
var staticRenderFns = []

export { render, staticRenderFns }